import React from 'react';

const OpenKnotsLoginHero = () => {
    return (
        <div className='opk-login-hero'>
            <div className='opk-login-tiles' />
            <div className='opk-login-vignette' />

            <img
                className='opk-login-brand'
                src={`${process.env.PUBLIC_URL}/images/129 Knots Logo 2.png`}
                alt='129 Knots'
            />
        </div>
    );
};

export default OpenKnotsLoginHero;